import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';

@Component({
  selector: 'app-alert-master-dialog',
  templateUrl: './alert-master-dialog.component.html',
  styleUrls: ['./alert-master-dialog.component.scss']
})
export class AlertMasterDialogComponent implements OnInit {
  public meisai: any = {};
  title = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public commonService: CommonService,
              public matDialogRef: MatDialogRef<AlertMasterDialogComponent>,) { }

  /**
   *
   */
  ngOnInit(): void {
    this.meisai = this.data;
    this.title = 'アラートプログラム修正';
  }
}
